__turbopack_context__.v({
  "embedMediaWrapper": "BoardSectionTileRaisedRight2Weather-module-scss-module__RWhRXG__embedMediaWrapper",
  "rightRoot": "BoardSectionTileRaisedRight2Weather-module-scss-module__RWhRXG__rightRoot",
  "teaserFixedHeight": "BoardSectionTileRaisedRight2Weather-module-scss-module__RWhRXG__teaserFixedHeight",
});
